"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffInSeconds = void 0;
var diffInSeconds = function (date1, date2) {
    if (typeof date1 === 'string') {
        date1 = new Date(date1);
    }
    if (typeof date2 === 'string') {
        date2 = new Date(date2);
    }
    return Math.abs((date1.getTime() - date2.getTime()) / 1000);
};
exports.diffInSeconds = diffInSeconds;
//# sourceMappingURL=utils.js.map